const CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
const CODE_LENGTH = 6;

/**
 * Generates a random room code for multiplayer games
 * Format: 6 alphanumeric characters (e.g., "A3X7K9")
 */
export const generateRoomCode = (): string => {
  let code = "";
  for (let i = 0; i < CODE_LENGTH; i++) {
    const randomIndex = Math.floor(Math.random() * CHARACTERS.length);
    code += CHARACTERS[randomIndex];
  }
  return code;
};

/**
 * Generates a unique game ID
 * Format: timestamp + random string
 */
export const generateGameId = (): string => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 9);
  return `${timestamp}_${random}`;
};

/**
 * Generates a unique player ID
 * Uses a combination of timestamp and random data
 */
export const generatePlayerId = (): string => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 15);
  return `player_${timestamp}_${random}`;
};
